import { motion } from 'framer-motion';

function Hero({ content }) {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <motion.div
        className="hero-copy"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <p className="eyebrow">{content.hero_eyebrow}</p>
        <h1 id="hero-heading">{content.hero_heading}</h1>
        <p className="hero-description">{content.hero_description}</p>
        <a className="cta" href={content.hero_cta_url}>
          {content.hero_cta_text}
        </a>
      </motion.div>

      <motion.div
        className="hero-visual"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.1 }}
      >
        <img
          src={content.hero_image.url}
          alt={content.hero_image.alt}
          fetchPriority="high"
        />
      </motion.div>
    </section>
  );
}

export default Hero;